import React from 'react';
import ReactDOM from 'react-dom';

//redux
import { Provider } from "react-redux";
import store from "./store";

import { configureFor } from "./config";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import moment from 'moment';

window.moment = moment;
// replace var with env var for future .env management
configureFor('production');

const AppBundle = (
  <Provider store={store}>
    <App />
  </Provider>
)

ReactDOM.render(AppBundle, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
